module.exports = __webpack_public_path__ + "static/media/previewBasicData.4bb33df9.png";